var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProcure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.69761 0.239258L2.37063 5.68341H9.02459L5.69761 0.239258ZM9.02448 12.3374C10.5278 12.3374 11.7466 11.1186 11.7466 9.61529C11.7466 8.11193 10.5278 6.89321 9.02448 6.89321C7.52112 6.89321 6.3024 8.11193 6.3024 9.61529C6.3024 11.1186 7.52112 12.3374 9.02448 12.3374ZM5.09266 7.19566H0.253418V12.0349H5.09266V7.19566Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcure);
export default __webpack_public_path__ + "static/media/procure.3f6de63daab02ddc011fbfb623117901.svg";
export { ForwardRef as ReactComponent };